'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _loggingEvent = require('./loggingEvent');

var _loggingEvent2 = _interopRequireDefault(_loggingEvent);

var _formatters = require('./formatters');

var _level = require('./level');

var _defaults = require('./defaults');

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Logger = function () {
	function Logger() {
		var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaults.logger;

		_classCallCheck(this, Logger);

		_extends(this, config);
	}

	_createClass(Logger, [{
		key: 'applyFormatters',
		value: function applyFormatters(event) {
			var _this = this;

			if (!this.formatters || this.formatters.length < 1) {
				return;
			}
			Object.keys(this.formatters).forEach(function (name) {
				if (!event[name]) {
					return;
				}
				try {
					event[name] = _this.formatters[name](event[name]);
				} catch (err) {
					console.warn('There was an error applying a log formatter.', err);
				}
			});
		}

		/**
   * main log method logging to all available appenders
   */

	}, {
		key: 'log',
		value: function log(minLevel, args) {
			var loggingEvent = new _loggingEvent2.default(this.name, _level.Level.toString(minLevel));

			if (args[0] instanceof Error) {
				loggingEvent.exception = (0, _formatters.formatError)(args[0]);
				loggingEvent.message = loggingEvent.exception.message;
			} else if ((0, _helpers.isString)(args[0])) {
				loggingEvent.message = args[0];
				if (args[1] instanceof Error) {
					loggingEvent.exception = (0, _formatters.formatError)(args[1]);
				}
			} else if ((0, _helpers.isObject)(args[0]) && !(args[0] instanceof Error)) {
				_extends(loggingEvent, args[0]);
			}

			this.applyFormatters(loggingEvent);
			_extends(loggingEvent, this.globals);
			this.callback(loggingEvent);
		}
	}], [{
		key: 'createLogger',
		value: function createLogger(config) {
			var configuration = {
				name: Logger.validateName(config.name),
				level: Logger.validateLevel(config.name, config.level),
				formatters: Logger.validateFormatters(config.formatters),
				globals: Logger.validateGlobals(config.globals),
				callback: Logger.validateCallback(config.callback)
			};

			Logger.prototype.trace = Logger.createEmitters(_level.Level.TRACE);
			Logger.prototype.debug = Logger.createEmitters(_level.Level.DEBUG);
			Logger.prototype.info = Logger.createEmitters(_level.Level.INFO);
			Logger.prototype.warn = Logger.createEmitters(_level.Level.WARN);
			Logger.prototype.error = Logger.createEmitters(_level.Level.ERROR);
			Logger.prototype.fatal = Logger.createEmitters(_level.Level.FATAL);

			return new Logger(configuration);
		}
	}, {
		key: 'validateName',
		value: function validateName(name) {
			if ((0, _helpers.isString)(name)) {
				return name;
			}
			throw new Error('Invalid logger name "' + name + '". Must be a non-empty string.');
		}
	}, {
		key: 'validateCallback',
		value: function validateCallback(callback) {
			if ((0, _helpers.isFunction)(callback)) {
				return callback;
			}
			throw new Error('Invalid logger callback. Must be a of type function.');
		}
	}, {
		key: 'validateFormatters',
		value: function validateFormatters(formatters) {
			if ((0, _helpers.isObject)(formatters)) {
				return formatters;
			}
			return {};
		}
	}, {
		key: 'validateLevel',
		value: function validateLevel(name, logLevel) {
			if ((0, _helpers.isNumeric)(logLevel)) {
				return logLevel;
			}
			console.log('Invalid logging level for "' + name + '". Defaulting to "ERROR".');
			return _level.Level.ERROR;
		}
	}, {
		key: 'validateGlobals',
		value: function validateGlobals(globals) {
			if (typeof globals === 'undefined') {
				return {};
			}

			if ((0, _helpers.isObject)(globals)) {
				return globals;
			}

			console.log('Invalid global configurations. Must be a non-empty object.');
			return {};
		}
	}, {
		key: 'createEmitters',
		value: function createEmitters(level) {
			return function () {
				if (this.level <= level) {
					this.log(level, (0, _lodash2.default)(arguments));
				}
			};
		}
	}]);

	return Logger;
}();

exports.default = Logger;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins/lib/Logger.js
// module id = 758
// module chunks = 0